<template>
  <div class="kbx-trigger-content">
    <input
      type="text"
      class="kbx-trigger-btn naked"
      v-if="boxConfig.trigger_button.kind === 'naked'"
      :value="boxConfig.trigger_button.text"
      @change="boxUpdateConfig({ item: 'trigger_button', key: 'text', value: $event.target.value })"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  methods: mapActions([
    'boxUpdateConfig',
  ]),
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Naked.vue?86c9ace2
 **/